import React, { FC, useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { IWallet } from '@sparling/financial-common'
import { Typography } from '@mui/material'
import { GreenButton } from '../../../../../../../components/Dashboard/Buttons/GreenButton'
import { TableComponent } from '../../../../../../../components/Dashboard/Table'
import { icons } from '../../../../../../../constants/icons'
import { columns } from './WalletsList'
import { WalletsModal } from './WalletsModal'
import { userAvailableWalletCurrenciesSelector, userWalletsSelector } from '../../../../../../../store/selectors'
import {
  openAddNewWalletPopup,
  readUserWalletsRequest,
  resetAddNewWalletPopup,
} from '../../../../../../../store/actions'
import { RemoveConfirmationModal } from './RemoveConfirmationModal'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    height: '100%',
  },
  titleWrap: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minWidth: 400,
  },
  table: {
    paddingTop: theme.spacing(2),
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
}))

export const Wallets: FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [isSubmit, setIsSubmit] = useState<boolean>(true)
  const { data, status } = useSelector(userWalletsSelector)
  const userAvailableWalletCurrencies = useSelector(userAvailableWalletCurrenciesSelector, shallowEqual)
  const [isOpenAccountModal, setOpenAccountModal] = useState<boolean>(false)
  const [isOpenRemoveConfirmationModal, setIsOpenRemoveConfirmationModal] = useState<boolean>(false)
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null)

  const loadAccountsData = useCallback(
    (page = 1) => {
      dispatch(
        readUserWalletsRequest({
          page,
        }),
      )
    },
    [dispatch],
  )

  useEffect(() => {
    loadAccountsData()
  }, [loadAccountsData])

  const getSelectedElementIdHandle = useCallback((id) => {
    setSelectedAccountId(id)
  }, [])

  const openWalletModalHandle = useCallback(() => {
    setIsSubmit(true)
    // setOpenAccountModal(true)
    dispatch(resetAddNewWalletPopup())
    dispatch(
      openAddNewWalletPopup({
        open: true,
      }),
    )
    setSelectedAccountId(null)
  }, [dispatch])

  const showWalletModalHandle = useCallback(() => {
    openWalletModalHandle()
    setIsSubmit(false)
  }, [openWalletModalHandle])

  const openRemoveConfirmationWalletModalHandle = useCallback(() => {
    setIsOpenRemoveConfirmationModal(true)
    setSelectedAccountId(null)
  }, [])

  // eslint-disable-next-line no-unused-expressions,no-sequences
  void showWalletModalHandle, openRemoveConfirmationWalletModalHandle

  const closeWalletModalHandle = useCallback(() => setOpenAccountModal(false), [])
  const closeRemoveConfirmationWalletModalHandle = useCallback(() => setIsOpenRemoveConfirmationModal(false), [])

  return (
    <Grid container display={'flex'}>
      <Grid container className={classes.container}>
        <Grid container className={classes.titleWrap}>
          <Grid item xs={8} display="flex">
            <Typography variant={'h6'}>Wallets</Typography>
          </Grid>
          <Grid item xs={4} display="flex" justifyContent={'flex-end'}>
            <GreenButton
              width={140}
              prefix={icons.ADD}
              ml={8}
              text={'Add Wallet'}
              onClick={openWalletModalHandle}
              disabled={!userAvailableWalletCurrencies.length}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.table}>
          <TableComponent
            id={'internal-wallets'}
            page={data.meta.currentPage}
            getUserId={getSelectedElementIdHandle}
            columns={columns}
            data={data.items}
            params={data.meta}
            // onShow={showWalletModalHandle}
            // onEdit={openWalletModalHandle}
            // onDelete={openRemoveConfirmationWalletModalHandle}
            loading={status === 'LOADING'}
            loadData={loadAccountsData}
          ></TableComponent>
        </Grid>
      </Grid>
      {isOpenAccountModal && (
        <WalletsModal
          isOpen={true}
          isSubmit={isSubmit}
          modalClose={closeWalletModalHandle}
          currencies={userAvailableWalletCurrencies}
        />
      )}
      <RemoveConfirmationModal
        wallet={data.items.find((item) => item.id === selectedAccountId) as IWallet}
        isOpen={isOpenRemoveConfirmationModal}
        onClose={closeRemoveConfirmationWalletModalHandle}
      />
    </Grid>
  )
}
